document.addEventListener('DOMContentLoaded', function () {
    $('.document-row').on('click', function () {
        /* Not too happy with this, but seems to be the easiest way to achieve this */
        window.location = $(this).find('[data-download-link]').attr('href');
        return false;
    });
});